var $ = require('jquery');

$('.js-card-people__toggle-bio').click(function () {
    // console.log( 'clicked bio toggle' );

    var parent_section = $(this).parents('.people-listing');
    var parent_li = $(this).parents('.people-listing__card-item');
    var this_person_counter = parent_li.data('peopleCounter');

    var target_bio_item = parent_section.find('.people-listing__bio-item[data-people-counter=' + this_person_counter + ']');

    if (!parent_li.hasClass('people-listing__card-item--is-active')) {
        ali_peopleListing_openBio(parent_section, this_person_counter);
    } else {
        ali_peopleListing_closeBio(parent_section);
    }

});



$('.js-people-listing__close').click(function () {
    var parent_section = $(this).parents('.people-listing');
    ali_peopleListing_closeBio(parent_section);
    // $('.people-listing__card-bio')
});



$('.js-people-listing__control').click(function () {

    var parent_section = $(this).parents('.people-listing');
    var active_person_counter = parent_section.data('peopleCounter');
    // console.log('active_person_counter = ' + active_person_counter);

    var new_active_person_counter = active_person_counter;

    // Next bio
    if ($(this).hasClass('js-people-listing__next')) {

        new_active_person_counter++;
        if (new_active_person_counter > parent_section.find('.people-listing__bio-item').length) {
            new_active_person_counter = 1;
        }

        // Previous bio
    } else if ($(this).hasClass('js-people-listing__prev')) {

        new_active_person_counter--;
        if (new_active_person_counter < 1) {
            new_active_person_counter = parent_section.find('.people-listing__bio-item').length;
        }

    }

    // console.log('new_active_person_counter = ' + new_active_person_counter);
    ali_peopleListing_openBio(parent_section, new_active_person_counter);

});


// function ali_peopleListing_openBio( parent_section, row_index, column_index ){
function ali_peopleListing_openBio(parent_section, new_active_person_counter) {
    var target_listing_card = parent_section.find('.people-listing__card-item[data-people-counter=' + new_active_person_counter + ']');
    var target_bio_item = parent_section.find('.people-listing__bio-item[data-people-counter=' + new_active_person_counter + ']');

    // Set the new active person counter on the parent section to keep track of the active person number.
    parent_section.data('peopleCounter', new_active_person_counter);

    // Set target card to active
    let prevCard = parent_section.find('.people-listing__card-item--is-active');
    prevCard.removeClass('people-listing__card-item--is-active');
    target_listing_card.addClass('people-listing__card-item--is-active');

    if ($(window).width() > 991) {

        // Show the target bio item/text.
        parent_section.find('.people-listing__bio-item').hide();


        var target_bio_container = target_bio_item.parents('.people-listing__bio-container');
        if (target_bio_container.is(':hidden')) {
            parent_section.find('.people-listing__bio-container').hide();
            target_bio_container.show(125);

            $("body,html").animate({
                    scrollTop: target_bio_container.offset().top - $('.site-header').height() - 100
                },
                333
            );

        }

        target_bio_item.show();

    } else {
        prevCard.css('height', 'auto');
        prevCard.find('.people-listing__card-bio').css('display', 'none');

        var card_bio = target_listing_card.find('.people-listing__card-bio');
        var target_listing_card_height = target_listing_card.outerHeight();

        card_bio.css('display', 'block');

        target_listing_card.css('height', target_listing_card_height + card_bio.outerHeight());

        $("body,html").animate({
            scrollTop: card_bio.offset().top - $('.site-header').height() - 50
        },
        333
    );
    }
}



function ali_peopleListing_closeBio(parent_section) {

    if ($(window).width() > 991) {
        parent_section.find('.people-listing__bio-container').hide(125);
        parent_section.find('.people-listing__bio-item').hide();

        parent_section.data('peopleCounter', 0);
    } else {
        parent_section.find('.people-listing__card-bio').css('display', 'none');
        parent_section.find('.people-listing__card-item--is-active').css('height', 'auto');
        // parent_section.find('.people-listing__card-item').css('height', 0);

        $("body,html").animate({
            scrollTop: parent_section.find('.people-listing__card-item--is-active').offset().top - $('.site-header').height() - 100
        }, 333);
    }

    parent_section.find('.people-listing__card-item').removeClass('people-listing__card-item--is-active');
}
